import { SxProps, Theme } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const orderItemTableItemPaintSX: Record<string, SxProps<Theme>> = {
	container: {
		width: '100%',
		gap: '5px',
	},
	semibold: {
		color: 'grey.500',
		fontWeight: OpenSansFontWeights.semibold,
	},
	detailsContainer: {
		gap: '10px',
		width: '100%',
	},
	transparentBase: {
		color: 'grey.500',
		lineHeight: '120%',
		fontSize: { xs: '12px', sm: '10px' },
	},
	transparentBaseContainer: {
		backgroundColor: 'alert.light',
		borderRadius: '3px',
		p: '5px',
		mt: '5px',
	},
	transparentBaseLink: {
		color: 'secondary.light',
		gap: '5px',
	},
};

export const orderItemTableItemPaintColorSX = (paintColor: {
	R: number;
	G: number;
	B: number;
}): SxProps<Theme> => ({
	backgroundColor: `rgb(${paintColor.R}, ${paintColor.G}, ${paintColor.B})`,
	width: 24,
	height: 40,
	borderRadius: '3px',
	border: '2px solid',
	borderColor: 'grey.100',
});

export const orderItemTableItemPaintTransparentBaseSX = (isMobile = false): SxProps<Theme> => ({
	backgroundColor: 'alert.light',
	height: isMobile ? 34 : 38,
	borderRadius: '3px',
	gap: '10px',
	p: isMobile ? '5px 0' : '5px',
	color: 'alert.main',
	alignSelf: 'center',
});

export const orderItemTableItemPaintQuantitySX = (isMobile = false): SxProps<Theme> => ({
	width: isMobile ? '100%' : '130px',
	minWidth: '130px',
});
